import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { StyledDateTile } from './styles';
import type { DateTileProps } from './types';
interface DateTilePropsExtended extends DateTileProps {
  /**
   * Optional props from Zag.js getDayTableCellTriggerProps (single / range modes).
   * When provided, Zag's onClick / onKeyDown / ARIA attributes are used instead of
   * the component's own fallbacks.
   */
  zagProps?: React.HTMLAttributes<HTMLElement>;
  /**
   * Mouse down on a tile starts a drag-range selection. Fires before any
   * `onClick`, including Zag's, so the parent can begin tracking the gesture.
   */
  onMouseDown?: (date: Date) => void;
}
const DateTile = t0 => {
  const $ = _c(42);
  const {
    date,
    isSelected: t1,
    isInRange: t2,
    isRangeStart: t3,
    isRangeEnd: t4,
    isRangeEndInComparisonRange: t5,
    isComparisonDate: t6,
    isInComparisonRange: t7,
    isComparisonRangeStart: t8,
    isComparisonRangeEnd: t9,
    isOverlap: t10,
    isOverlapStart: t11,
    isOverlapEnd: t12,
    isToday: t13,
    isDisabled: t14,
    isOutsideMonth: t15,
    isFirstInWeek: t16,
    isLastInWeek: t17,
    isFirstInMonth: t18,
    isLastInMonth: t19,
    onClick,
    onHover,
    zagProps,
    onMouseDown
  } = t0;
  const isSelected = t1 === undefined ? false : t1;
  const isInRange = t2 === undefined ? false : t2;
  const isRangeStart = t3 === undefined ? false : t3;
  const isRangeEnd = t4 === undefined ? false : t4;
  const isRangeEndInComparisonRange = t5 === undefined ? false : t5;
  const isComparisonDate = t6 === undefined ? false : t6;
  const isInComparisonRange = t7 === undefined ? false : t7;
  const isComparisonRangeStart = t8 === undefined ? false : t8;
  const isComparisonRangeEnd = t9 === undefined ? false : t9;
  const isOverlap = t10 === undefined ? false : t10;
  const isOverlapStart = t11 === undefined ? false : t11;
  const isOverlapEnd = t12 === undefined ? false : t12;
  const isToday = t13 === undefined ? false : t13;
  const isDisabled = t14 === undefined ? false : t14;
  const isOutsideMonth = t15 === undefined ? false : t15;
  const isFirstInWeek = t16 === undefined ? false : t16;
  const isLastInWeek = t17 === undefined ? false : t17;
  const isFirstInMonth = t18 === undefined ? false : t18;
  const isLastInMonth = t19 === undefined ? false : t19;
  let t20;
  if ($[0] !== date) {
    t20 = date.getDate();
    $[0] = date;
    $[1] = t20;
  } else {
    t20 = $[1];
  }
  const dayOfMonth = t20;
  let t21;
  if ($[2] !== date || $[3] !== isDisabled || $[4] !== onClick) {
    t21 = () => {
      if (!isDisabled && onClick != null) {
        onClick(date);
      }
    };
    $[2] = date;
    $[3] = isDisabled;
    $[4] = onClick;
    $[5] = t21;
  } else {
    t21 = $[5];
  }
  const handleClickFallback = t21;
  let t22;
  if ($[6] !== date || $[7] !== onHover) {
    t22 = () => {
      if (onHover != null) {
        onHover(date);
      }
    };
    $[6] = date;
    $[7] = onHover;
    $[8] = t22;
  } else {
    t22 = $[8];
  }
  const handleMouseEnter = t22;
  let t23;
  if ($[9] !== onHover) {
    t23 = () => {
      if (onHover != null) {
        onHover(null);
      }
    };
    $[9] = onHover;
    $[10] = t23;
  } else {
    t23 = $[10];
  }
  const handleMouseLeave = t23;
  let t24;
  if ($[11] !== date || $[12] !== isDisabled || $[13] !== onMouseDown) {
    t24 = event => {
      if (event.button !== 0 || isDisabled) {
        return;
      }
      event.preventDefault();
      if (onMouseDown != null) {
        onMouseDown(date);
      }
    };
    $[11] = date;
    $[12] = isDisabled;
    $[13] = onMouseDown;
    $[14] = t24;
  } else {
    t24 = $[14];
  }
  const handleMouseDown = t24;
  const defaultAriaLabel = `${dayOfMonth}${isToday ? ", Today" : ""}${isSelected ? ", Selected" : ""}`;
  const t25 = zagProps as React.ButtonHTMLAttributes<HTMLButtonElement>;
  const t26 = zagProps?.onClick ?? handleClickFallback;
  const t27 = zagProps?.["aria-label"] ?? defaultAriaLabel;
  let t28;
  if ($[15] !== dayOfMonth || $[16] !== handleMouseDown || $[17] !== handleMouseEnter || $[18] !== handleMouseLeave || $[19] !== isComparisonDate || $[20] !== isComparisonRangeEnd || $[21] !== isComparisonRangeStart || $[22] !== isDisabled || $[23] !== isFirstInMonth || $[24] !== isFirstInWeek || $[25] !== isInComparisonRange || $[26] !== isInRange || $[27] !== isLastInMonth || $[28] !== isLastInWeek || $[29] !== isOutsideMonth || $[30] !== isOverlap || $[31] !== isOverlapEnd || $[32] !== isOverlapStart || $[33] !== isRangeEnd || $[34] !== isRangeEndInComparisonRange || $[35] !== isRangeStart || $[36] !== isSelected || $[37] !== isToday || $[38] !== t25 || $[39] !== t26 || $[40] !== t27) {
    t28 = <StyledDateTile {...t25} onClick={t26} onMouseDown={handleMouseDown} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} $isSelected={isSelected} $isInRange={isInRange} $isRangeStart={isRangeStart} $isRangeEnd={isRangeEnd} $isRangeEndInComparisonRange={isRangeEndInComparisonRange} $isComparisonDate={isComparisonDate} $isInComparisonRange={isInComparisonRange} $isComparisonRangeStart={isComparisonRangeStart} $isComparisonRangeEnd={isComparisonRangeEnd} $isOverlap={isOverlap} $isOverlapStart={isOverlapStart} $isOverlapEnd={isOverlapEnd} $isToday={isToday} $isDisabled={isDisabled} $isOutsideMonth={isOutsideMonth} $isFirstInWeek={isFirstInWeek} $isLastInWeek={isLastInWeek} $isFirstInMonth={isFirstInMonth} $isLastInMonth={isLastInMonth} disabled={isDisabled} type="button" aria-pressed={isSelected} aria-label={t27}>{dayOfMonth}</StyledDateTile>;
    $[15] = dayOfMonth;
    $[16] = handleMouseDown;
    $[17] = handleMouseEnter;
    $[18] = handleMouseLeave;
    $[19] = isComparisonDate;
    $[20] = isComparisonRangeEnd;
    $[21] = isComparisonRangeStart;
    $[22] = isDisabled;
    $[23] = isFirstInMonth;
    $[24] = isFirstInWeek;
    $[25] = isInComparisonRange;
    $[26] = isInRange;
    $[27] = isLastInMonth;
    $[28] = isLastInWeek;
    $[29] = isOutsideMonth;
    $[30] = isOverlap;
    $[31] = isOverlapEnd;
    $[32] = isOverlapStart;
    $[33] = isRangeEnd;
    $[34] = isRangeEndInComparisonRange;
    $[35] = isRangeStart;
    $[36] = isSelected;
    $[37] = isToday;
    $[38] = t25;
    $[39] = t26;
    $[40] = t27;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  return t28;
};
DateTile.displayName = 'DateTile';

// Boolean style flags that drive the tile's visual output. Listed explicitly so
// the memo comparator stays in lock-step with the props the styled component reads.
const BOOLEAN_TILE_KEYS = ['isSelected', 'isInRange', 'isRangeStart', 'isRangeEnd', 'isRangeEndInComparisonRange', 'isComparisonDate', 'isInComparisonRange', 'isComparisonRangeStart', 'isComparisonRangeEnd', 'isOverlap', 'isOverlapStart', 'isOverlapEnd', 'isToday', 'isDisabled', 'isOutsideMonth', 'isFirstInWeek', 'isLastInWeek', 'isFirstInMonth', 'isLastInMonth'] as const;
const shallowEqualZagProps = (a?: React.HTMLAttributes<HTMLElement>, b?: React.HTMLAttributes<HTMLElement>): boolean => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) return false;
  return aKeys.every(key => {
    const valA = (a as Record<string, unknown>)[key];
    const valB = (b as Record<string, unknown>)[key];
    // Zag recreates its event handlers every render, so comparing them by
    // identity would always fail. Their behavior is bound to `date` (already
    // compared), so treat any two functions as equal.
    if (typeof valA === 'function' && typeof valB === 'function') return true;
    return Object.is(valA, valB);
  });
};

// Custom comparator: `date` and `zagProps` are non-primitive (a fresh Date and a
// fresh object from Zag's connect each render), so the default shallow compare
// would always re-render. We compare `date` by time, `zagProps` shallowly, the
// boolean flags by value, and the handlers by identity (they are stable).
const areTilePropsEqual = (prev: DateTilePropsExtended, next: DateTilePropsExtended): boolean => {
  if (prev.date.getTime() !== next.date.getTime()) return false;
  if (prev.onClick !== next.onClick) return false;
  if (prev.onHover !== next.onHover) return false;
  if (prev.onMouseDown !== next.onMouseDown) return false;
  for (const key of BOOLEAN_TILE_KEYS) {
    if (prev[key] !== next[key]) return false;
  }
  return shallowEqualZagProps(prev.zagProps, next.zagProps);
};
const MemoizedDateTile = React.memo(DateTile, areTilePropsEqual);
MemoizedDateTile.displayName = 'DateTile';
export default MemoizedDateTile;